module.exports = __webpack_public_path__ + "static/img/Aions_Mar_2.4ac00e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Aions_Mar/Aions_Mar_2.png
// module id = iL0e
// module chunks = 19